<template>
    <div class="bg-red-50 border-l-4 border-red-400 p-4">
        <div class="flex">
            <div class="flex-shrink-0">
                <ExclamationTriangleIcon class="h-5 w-5 text-red-400"/>
            </div>
            <div class="ml-3">
                <p class="text-sm text-red-700">
                    {{ text }}
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import {ExclamationTriangleIcon} from "@heroicons/vue/24/outline";

export default {
    props: ['text'],
    components: {
        ExclamationTriangleIcon
    }
}
</script>

<style scoped>

</style>
